export const GET_ALL_FEEDBACK = "get/all/feedback";
export const ADD_FEEDBACK = "add/feedback";

export const LOADING_FEEDBACK = "loading/feedback";
export const ERROR_FEEDBACK = "error/feedback";
export const RESET_FEEDBACK = "reset/feedback";
